import $ from 'init/jquery'
import merge from 'lodash/merge'
import isFunction from 'lodash/isFunction'
import { isMobile } from 'init/is-mobile'

/**
 * Проверка наличия обрезанных свойством overflow элементов в контейнере
 *
 * @param {jQuery} wrapper
 * @returns {Array} невидимые элементы
 */
export const getOverflowedElements = wrapper => {
  let invisibleItems = []
  if (wrapper && wrapper.childElementCount) {
    for (let i = 0; i < wrapper.childElementCount; i++) {
      if (wrapper.children[i].offsetTop + wrapper.children[i].offsetHeight >
        wrapper.offsetTop + wrapper.offsetHeight ||
        wrapper.children[i].offsetLeft + wrapper.children[i].offsetWidth >
        wrapper.offsetLeft + wrapper.offsetWidth) {
        invisibleItems.push(wrapper.children[i])
      }
    }
  }
  return invisibleItems
}

/**
 * Скроллит до элемента
 *
 * @param {jQuery|string} element - элемент или селектор
 * @param {Object} newOptions - опции анимации
 * @returns {boolean} - найден ли элемент, до которого будет происходить скролл
 */
export const scrollTo = (element, newOptions) => {
  let $element = (element instanceof $)
    ? element
    : $(element)

  if ($element.length) {
    let options = {
      duration: 'slow',
    }
    merge(options, newOptions)

    $('html, body').animate({
      scrollTop: $element.offset().top,
    }, options)

    return true
  }

  return false
}

/**
 * Изменение размера тестовой области в соответствии с содержимым
 * @param {jquery} $el
 */
export const resizeTextarea = $el => {
  // Сначала уменьшаем до 1, чтобы можно было получить правильную высоту текста
  $el.each(function () {
    const $item = $(this)
    $item.css({
      height: 1,
    })
      .css({
        height: $item.prop('scrollHeight') + 10,
        resize: 'none',
      })
  })
}

/**
 * Проверяет находится ли элемент во вьюпорте
 * @param {jQuery} $el
 * @param {number} safeGap - расстояние до элемента, в px, при достижении которого вернётся true
 * @returns {boolean}
 */
export const isElementInViewport = ($el, safeGap = 0) => {
  const $window = $(window)

  // верхние и нижние координаты текущей области просмотра
  const wTop = $window.scrollTop()
  const wBottom = wTop + $window.height()

  const elTop = $el.offset().top
  const elBottom = elTop + $el.outerHeight()

  return elTop - safeGap < wBottom && elBottom > wTop
}

/**
 * Возвращает булево значение, определяющее, находится ли прямоугольник полностью внутри другого.
 * @param {DOMRect} innerRect Внутренний ограничивающий прямоугольник.
 * @param {DOMRect} rootRect Внешний ограничивающий прямоугольник.
 * @returns {boolean} Булево значение, определяющее, находится ли геометрически объект внутри другого.
 */
export function isInsideRect (innerRect, rootRect) {
  let result = false
  if (innerRect || rootRect) {
    result = (
      innerRect.left >= rootRect.left
      && innerRect.right <= rootRect.right
      && innerRect.top >= rootRect.top
      && innerRect.bottom <= rootRect.bottom
    )
  }
  return result
}

/**
 * Переключает возможность увеличения страницы в мета-теге.
 * @param {boolean} state Признак пользовательского увеличения\уменьшения страницы.
 */
export const toggleViewportZoom = state => {
  const baseViewport = 'width=device-width, initial-scale=1'
  document.querySelector('meta[name=viewport]').setAttribute(
    'content',
    state
      ? baseViewport
      : `${baseViewport}, user-scalable=0`
  )
}

/**
 * Предотвращает зум на мобильных устройствах.
 */
export const preventInputZoom = () => {
  if (isMobile) {
    toggleViewportZoom(false)
    setTimeout(toggleViewportZoom.bind(null, true), 100)
  }
}

/**
 * Скрывает элементы так, чтобы количество их рядов стало равным заданному.
 * Добавляет кнопку типа "Показать ещё .."
 * @param {jQuery} $parentContainer - родительский контейнер с элементами.
 * @param {jQuery} $targetElements - целевые элементы.
 * @param {number} desiredRowsCount - количество рядов элементов, которые должны быть видны.
 * @param {Function} moreButtonTemplate - шаблон кнопки типа "Показать ещё".
 * @param {Function} onMoreButtonClick - функция, которая навесится на кнопку "Показать еще"
 * @param {boolean} isEqualElementsWidth - ширина целевых элементов одинакова.
 * @param {string} excessElementsClassName - класс добавляющийся к элементам которые будут скрыты..
 * @returns {jQuery|null} - элемент кнопки типа "Показать ещё", если передан шаблон.
 */
export const hideExcessElementsAndAddButton = (
  $parentContainer,
  $targetElements,
  desiredRowsCount,
  moreButtonTemplate = null,
  onMoreButtonClick = null,
  isEqualElementsWidth = false,
  excessElementsClassName = 'not_display',
) => {
  $targetElements.removeClass(excessElementsClassName)
  const parentContainerHeight = $parentContainer.innerHeight()
  const targetElementsLength = $targetElements.length
  let targetElementHeight = 0
  let $moreButton = null

  if ($targetElements.length) {
    targetElementHeight = $targetElements.eq(0).outerHeight(true)
  }
  const desiredHeight = targetElementHeight * desiredRowsCount
  if (parentContainerHeight >= desiredHeight) {
    const parentContainerWidth = Math.floor($parentContainer.innerWidth())
    let rowOfTabsWidth = 0
    let firstHiddenTabIndex = 0
    const parentWidth = moreButtonTemplate
      ? parentContainerWidth - $targetElements.eq(0).outerWidth(true)
      : parentContainerWidth
    if (isEqualElementsWidth) {
      firstHiddenTabIndex = Math.floor((parentWidth * desiredRowsCount) / $targetElements.eq(0).outerWidth(true))
    } else {
      for (let i = 0; i < targetElementsLength; i++) {
        rowOfTabsWidth += Math.ceil($targetElements.eq(i).outerWidth(true))
        firstHiddenTabIndex = i
        if (rowOfTabsWidth > (parentWidth * desiredRowsCount)) {
          break
        }
      }
    }
    const hiddenElementsCount = targetElementsLength - firstHiddenTabIndex
    if (hiddenElementsCount > 1) {
      const $hiddenElements = $targetElements
        .slice(firstHiddenTabIndex)
        .addClass(excessElementsClassName)
      if (moreButtonTemplate) {
        $moreButton = $(moreButtonTemplate({
          hiddenFiltersQty: $hiddenElements.length,
        }))
        $hiddenElements.eq(-1).after($moreButton)
        if (onMoreButtonClick && isFunction(onMoreButtonClick)) {
          $moreButton.one('click', onMoreButtonClick)
        }
      }
    }
  }

  return $moreButton
}

/**
 * Переключает css-класс для управления overflow у body.
 * @param {boolean} isHidden Булево значение, показывающее, нужно ли установить overflow в hidden.
 */
export function toggleBodyOverflow (isHidden) {
  const className = 'body-hidden'
  if (isHidden) {
    document.body.classList.add(className)
  } else {
    document.body.classList.remove(className)
  }
}
